import angular from 'angular';
import _ from 'lodash-es';
import APIV5 from '~/models/api';
import './postal-address-input.directive';
import $ from 'jquery';
import ModalPostalAddressController from './modal/modal-postal-address.controller';
import modalTemplate from './modal/modal-postal-address.html';

/* global Knitiv */

class PostalAddressController {
	/**
	 * Références conservées pour pouvoir désabonner précisément dans $onDestroy.
	 *
	 * @type {?(event: any) => void}
	 */
	#onDocumentClick = null;

	/** @type {?(event: KeyboardEvent) => void} */
	#onKeyDown = null;

	/* @ngInject */
	/**
	 * @param {any} $$debounce
	 * @param {import('angular').IAttributes} $attrs
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').IDocumentService} $document
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').IParseService} $parse
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('angular').ui.bootstrap.IPositionService} $uibPosition
	 * @param {import('angular').IWindowService} $window
	 * @param {any} AddressService
	 * @param {any} Notification
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(
		$$debounce,
		$attrs,
		$compile,
		$document,
		$element,
		$parse,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		$uibPosition,
		$window,
		AddressService,
		Notification,
		User,
	) {
		/**
		 * Active selected match index
		 *
		 * @type {number}
		 */
		this.activeIdx = -1;

		/**
		 * Disabled state
		 *
		 * @type {boolean}
		 */
		this.disabled = false;

		/**
		 * Input has focus?
		 *
		 * @type {boolean}
		 */
		this.hasFocus = false;

		/**
		 * Component key
		 *
		 * @type {string}
		 */
		this.key = '';

		/**
		 * Loading state flag
		 *
		 * @type {boolean}
		 */
		this.loading = false;

		/**
		 * Google Maps API key
		 *
		 * @type {string}
		 */
		this.mapsKey = '';

		/**
		 * Matches displayed in popup
		 *
		 * @type {any[]}
		 */
		this.matches = [];

		/**
		 * Default progress type
		 *
		 * @type {boolean}
		 */
		this.moveInProgress = false;

		/**
		 * Model controller
		 *
		 * @type {?import('angular').INgModelController}
		 */
		this.ngModelCtrl = null;

		/**
		 * ngModel options
		 *
		 * @type {any}
		 */
		this.ngModelOptions = {};

		/**
		 * Select callback
		 *
		 * @type {?Function}
		 */
		this.onSelect = null;

		/**
		 * Component options
		 *
		 * @type {any}
		 */
		this.options = {};

		/**
		 * kform controller
		 *
		 * @type {?import('../kform/kform.controller').default}
		 */
		this.parent = null;

		/**
		 * Input placeholder
		 *
		 * @type {string}
		 */
		this.placeholder = '';

		/**
		 * Popup element
		 *
		 * @type {any}
		 */
		this.$popUpElement = null;

		/**
		 * Results popup position
		 *
		 * @type {any}
		 */
		this.position = {};

		/**
		 * User input query
		 *
		 * @type {string}
		 * @description we need to propagate user's query so we can higlight matches
		 */
		this.query = '';

		/**
		 * Shows the map
		 *
		 * @type {boolean}
		 */
		this.showMap = false;

		/**
		 * Current value (from ng-model)
		 *
		 * @type {import('~/scripts/services/model/address').default | undefined}
		 */
		this.value = undefined;

		this.$$debounce = $$debounce;
		this.$attrs = $attrs;
		this.$compile = $compile;
		this.$document = $document;
		this.$element = $element;
		this.$parse = $parse;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$uibPosition = $uibPosition;
		this.$window = $window;
		this.AddressService = AddressService;
		this.Notification = Notification;
		this.User = User;
		this.$inputElement = $($element).find('input');
	}

	/**
	 * Set flag to determine if results popup should be opened
	 *
	 * @param {boolean} isOpen Open flag
	 */
	assignIsOpen(isOpen) {
		this.$scope.mfPopup = isOpen;
	}

	/**
	 * Remove  value
	 *
	 * @param {Event} event Browser event
	 */
	delValue(event) {
		this.value = undefined;
		this.$inputElement.val('');

		this.$timeout(() => {
			this.ngModelCtrl?.$validate();
			this.ngModelCtrl?.$setDirty();

			if (typeof this.onSelect === 'function') {
				this.onSelect({
					$item:  undefined,
					$event: event,
				});
			}
		});
	}

	/**
	 * Keep reference to click handler to unbind it
	 *
	 * @param {any} event Browser event
	 */
	dismissClickHandler(event) {
		// Issue #3973
		// Firefox treats right click as a click on document
		// @ts-ignore
		if (this.$inputElement[0] !== event.target && event.which !== 3 && this.matches.length > 0) {
			this.resetMatches();
			if (!this.$rootScope.$$phase) {
				this.$scope.$digest();
			}
		}
	}

	/**
	 * @param {any[]} results
	 * @param {string} status
	 */
	displayResults(results, status) {
		this.recalculatePosition();
		this.matches.length = 0;
		let addCreate = this.query.trim() !== '';
		if (status === 'OK' && results.length > 0) {
			this.activeIdx = 0;
			for (const result of results) {
				this.matches.push({
					kid:        result.place_id,
					isa_name:   '',
					name:       result.description,
					selectable: 1,
				});
				if (this.query && result.description.toLowerCase().trim() === this.query.toLowerCase().trim()) {
					addCreate = false;
				}
			}
			this.$inputElement.attr('aria-expanded', 'true');
		}
		else if (!this.query) {
			this.resetMatches();
		}

		if (addCreate) {
			this.matches.unshift({
				kid:        '__create',
				isa_name:   '',
				name:       null,
				selectable: 1,
			});
		}
		else if (this.matches.length === 0) {
			this.matches.unshift({
				kid:        '__none',
				isa_name:   '',
				name:       this.$translate.instant('common.no-element-found'),
				selectable: 0,
			});
		}

		this.loading = false;
	}

	/**
	 * Edit address by opening modal window
	 *
	 * @param {import('~/scripts/services/model/address').default} address Address instance
	 * @param {Event} event Browser event
	 */
	editAddress(address, event) {
		let oldAddress = this.$scope.address;
		const addressService = this.AddressService;
		if (!(oldAddress instanceof addressService.constructor)) {
			oldAddress = addressService.set(oldAddress);
		}

		this.openModalPostalAddress(address).then(newAddress => {
			this.setModelValue(this.$scope, newAddress);
			if (typeof this.onSelect === 'function') {
				this.onSelect(this.$scope, {
					$value: newAddress,
					$event: event,
				});
			}
			this.$inputElement.val(newAddress.format().join(', '));
			if (!_.isEqual(oldAddress, newAddress)) {
				this.ngModelCtrl?.$setDirty();
			}
			this.$inputElement.trigger('focus');
			this.$timeout(() => {
				this.ngModelCtrl?.$setValidity('validAddress', true);
				// this.$scope.$apply();
			});
			return this.$q.resolve();
		}).catch(() => {
			this.$inputElement.val(oldAddress ? oldAddress.format().join(', ') : '');
			this.$inputElement.trigger('focus');
		});
	}

	/**
	 * Open modal window
	 *
	 * @param {import('~/scripts/services/model/address').default} address Address instance
	 * @returns {import('angular').IPromise<any>} Promise result
	 */
	openModalPostalAddress(address) {
		return this.$uibModal.open({
			ariaLabelledBy:  'modal-postal-address-title',
			ariaDescribedBy: 'modal-postal-address-body',
			template:        modalTemplate,
			controller:      ModalPostalAddressController,
			controllerAs:    '$ctrl',
			resolve:         {
				address() {
					return address;
				},
				disabled: () => this.disabled,
			},
			size:            'lg',
		}).result;
	}

	/**
	 * recalculate actual position and set new values to scope after digest loop is popup in right position
	 */
	recalculatePosition() {
		this.position = this.$uibPosition.position(this.$inputElement);
		this.position.top += this.$inputElement.prop('offsetHeight');
	}

	resetMatches() {
		this.matches.length = 0;
		this.activeIdx = -1;
		this.$inputElement.attr('aria-expanded', 'false');
	}

	/**
	 * @param {any} item
	 * @param {KeyboardEvent} event
	 */
	select(item, event) {
		// called from within the $digest() cycle
		this.ngModelCtrl?.$setValidity('editable', true);
		this.ngModelCtrl?.$setValidity('parse', true);

		this.resetMatches();
		if (item.kid === '__create') {
			const newAddress = this.AddressService;
			newAddress.country = (this.options.defaults && this.options.defaults.country) || 'FR';
			newAddress.parse(this.query)
				.then((
					/** @type {import('~/scripts/services/model/address').default} */ address2,
				) => this.openModalPostalAddress(address2))
				.then((
					/** @type {import('~/scripts/services/model/address').default} */ updatedAddress,
				) => {
					this.setModelValue(this.$scope, updatedAddress);
					this.ngModelCtrl?.$setValidity('validAddress', true);
					if (!_.isEqual(newAddress, updatedAddress)) {
						this.ngModelCtrl?.$setDirty();
					}
					if (typeof this.onSelect === 'function') {
						this.onSelect(this.$scope, {
							$value: updatedAddress,
							$event: event,
						});
					}
					this.$inputElement.val(updatedAddress.format().join(', '));
					_.merge(newAddress, updatedAddress);
					this.$inputElement.trigger('focus');
					return this.$q.resolve();
				})
				.catch((/** @type {any} */ error) => {
					this.ngModelCtrl?.$setValidity('validAddress', false);
					this.$inputElement.val('');
					this.$inputElement.trigger('focus');
					this.Notification.error({
						title:     this.$translate.instant('error.title'),
						message:   error,
					});
				});
		}
		else {
			const mapElement = angular.element('<div id="map"></div>');

			// @ts-ignore
			const map = new window.google.maps.Map(mapElement.get(0)); // jshint ignore:line

			// noinspection JSUnresolvedVariable,JSUnresolvedFunction
			const service = new window.google.maps.places.PlacesService(map); // jshint ignore:line

			service.getDetails({
				placeId: item.kid,
				fields:  [
					'name',
					'address_component',
					'geometry',
				],
			}, result => {
				const address = this.AddressService;
				address.name = item.name;
				address.location = {
					lat:  result?.geometry?.location?.lat(),
					lng:  result?.geometry?.location?.lng(),
					zoom: 17,
				};
				address.place_id = item.kid;
				if (result?.address_components) {
					for (const component of result.address_components) {
						for (const type of component.types) {
							address[type] = type === 'country' ? component.short_name : component.long_name;
						}
					}
				}

				return APIV5.instance.input(
					{
						inherits: false,
						order:  'K_NODE;COUNTRY',
						query: address.country,
						lang_kid: 'K_NODE;CODE',
						parent: null,
					},
					{ id: 'postal-address.select' },
				)
					.then(backAddress => {
						address.country = 'kid' in backAddress.identical ? [backAddress.identical] : null;
						return this.$q.resolve(address);
					})
					.then(address2 => this.openModalPostalAddress(address2))
					.then(updatedAddress => {
						this.setModelValue(this.$scope, updatedAddress);
						this.ngModelCtrl?.$setValidity('validAddress', true);
						if (typeof this.onSelect === 'function') {
							this.onSelect(this.$scope, {
								$value: updatedAddress,
								$event: event,
							});
						}
						this.$inputElement.val(updatedAddress.format().join(', '));
						this.$inputElement.trigger('focus');
						if (!_.isEqual(address, updatedAddress)) {
							this.ngModelCtrl?.$setDirty();
							_.extend(address, updatedAddress);
						}
						return this.$q.resolve();
					})
					.catch(() => {
						this.ngModelCtrl?.$setValidity('validAddress', false);
						this.ngModelCtrl?.$setDirty();
						this.$inputElement.val('');
						this.$inputElement.trigger('focus');
					});
			});

			// return focus to the input element if a match was selected via a mouse click event
			// use timeout to avoid $rootScope:inprog error
			// this.$timeout(function () {
			// 	// this.$inputElement.val(item.name);
			// 	this.$inputElement.trigger('focus');
			// }, 0, false);
		}
	}

	/**
	 * model setter executed upon match selection
	 *
	 * @param {any} scope
	 * @param {any} [newValue]
	 * @returns {any}
	 */
	setModelValue(scope, newValue) {
		this.value = newValue;
		const parsedModel = this.$parse(this.$attrs.ngModel);
		const invokeModelSetter = this.$parse(`${this.$attrs.ngModel}($$$p)`);
		if (typeof parsedModel(this.$scope) === 'function'
			&& this.ngModelOptions.getOption('getterSetter')) {
			return invokeModelSetter(scope, { $$$p: newValue });
		}

		return parsedModel.assign(scope, newValue);
	}

	// noinspection JSUnusedGlobalSymbols
	$onDestroy() {
		// .off('click') sans référence retirait les handlers click de tous les autres
		// composants (chaque mf y pose le sien) ; on ne retire plus que le nôtre.
		if (this.#onDocumentClick) {
			this.$document.off('click', this.#onDocumentClick);
			this.#onDocumentClick = null;
		}

		if (this.#onKeyDown) {
			this.$window.removeEventListener('keydown', this.#onKeyDown);
			this.#onKeyDown = null;
		}

		this.setModelValue(this.$scope);
		if (this.ngModelCtrl) {
			this.ngModelCtrl.$setValidity('validAddress', true);
			if (this.$inputElement.val() !== '') {
				this.$inputElement.val('');
				this.ngModelCtrl.$setDirty();
			}
		}

		// Prevent jQuery cache memory leak
		if (this.$popUpElement) {
			// @ts-ignore
			this.$popUpElement.remove();
		}
	}

	$onInit() {
		const HOT_KEYS = new Set([
			'Tab',
			'Enter',
			'NumpadEnter',
			'Escape',
			'ArrowUp',
			'ArrowDown',
			//
			// 9, // tab
			// 13, // enter
			// 27, // escape
			// 38, // up arrow
			// 40, // down arrow
		]);

		// SUPPORTED ATTRIBUTES (OPTIONS)

		this.mapsKey = this.User.getAppConfig().GOOGLE?.key ?? '';

		// create a child scope for the typeahead directive so we are not polluting original scope
		// with typeahead-specific data (matches, query etc.)
		const scope = this.$scope.$new();
		const offDestroy = this.$scope.$on('$destroy', () => {
			scope.$destroy();
		});
		scope.$on('$destroy', offDestroy);

		// WAI-ARIA
		const popupId = `postal-address-${scope.$id}-${Math.floor(Math.random() * 10_000)}`;

		// @ts-ignore
		this.$inputElement = angular.element($(this.$element).find('input').get(0));
		this.$inputElement.attr({
			'aria-autocomplete': 'list',
			'aria-expanded':     false,
			'aria-owns':         popupId,
		});

		if ('focus' in this.$attrs) {
			this.$timeout(() => {
				this.$inputElement.trigger('focus');
			});
		}

		// pop-up element used to display matches
		// @ts-ignore
		this.$popUpElement = $('<mf-popup/>').attr({
			id:                 popupId,
			matches:            '$ctrl.matches',
			active:             '$ctrl.activeIdx',
			select:             '$ctrl.select(item, event)',
			'move-in-progress': '$ctrl.moveInProgress',
			query:              '$ctrl.query',
			position:           '$ctrl.position',
			'assign-is-open':   '$ctrl.assignIsOpen(isOpen)',
			debounce:           '$ctrl.debounceUpdate',
		});

		const getMatchId = (/** @type {number} */ index) => `${popupId}-option-${index}`;

		// Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
		// This attribute is added or removed automatically when the `activeIdx` changes.
		scope.$watch('$ctrl.activeIdx', (/** @type {number} */ index) => {
			if (index < 0) {
				this.$inputElement.removeAttr('aria-activedescendant');
			}
			else {
				this.$inputElement.attr('aria-activedescendant', getMatchId(index));
			}
		});

		// Default progress type
		scope.moveInProgress = false;

		// we need to propagate user's query so we can higlight matches
		this.query = '';

		this.resetMatches();

		// bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
		this.#onKeyDown = event => {
			// typeahead is open and an "interesting" key was pressed
			if (this.matches.length === 0 || !HOT_KEYS.has(event.code)) {
				return;
			}

			const shouldSelect = event.code === 'Enter' || event.code === 'Tab';

			/**
			 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
			 * or
			 * shift + tab is pressed to bring focus to the previous element
			 * then clear the results
			 */
			if ((this.activeIdx === -1 && shouldSelect) || (event.code === 'Tab' && !!event.shiftKey)) {
				this.resetMatches();
				scope.$digest();
				return;
			}

			event.preventDefault();
			let target;
			switch (event.code) {
			case 'Escape': { // escape
				event.stopPropagation();
				this.resetMatches();
				this.$scope.$digest();
				break;
			}

			case 'ArrowUp': { // up arrow
				this.activeIdx = (this.activeIdx > 0 ? this.activeIdx : this.matches.length) - 1;
				scope.$digest();
				target = this.$popUpElement[0].querySelectorAll('.mf-match')[this.activeIdx];
				target.parentNode.scrollTop = target.offsetTop;
				break;
			}

			case 'ArrowDown': { // down arrow
				this.activeIdx = (this.activeIdx + 1) % this.matches.length;
				scope.$digest();
				target = this.$popUpElement[0].querySelectorAll('.mf-match')[this.activeIdx];
				target.parentNode.scrollTop = target.offsetTop;
				break;
			}

			default: {
				if (shouldSelect) {
					scope.$apply(() => {
						if (angular.isNumber(this.debounceUpdate) || angular.isObject(this.debounceUpdate)) {
							this.$$debounce(() => {
								this.select(this.matches[this.activeIdx], event);
							}, angular.isNumber(this.debounceUpdate) ? this.debounceUpdate : this.debounceUpdate.default);
						}
						else {
							this.select(this.matches[this.activeIdx], event);
						}
					});
				}
			}
			}
		};
		this.$window.addEventListener('keydown', this.#onKeyDown);

		this.#onDocumentClick = event => this.dismissClickHandler(event);
		this.$document.on('click', this.#onDocumentClick);

		const $popup = this.$compile(this.$popUpElement)(scope);

		this.$inputElement.after($popup);

		if (this.ngModelCtrl) {
			// @ts-ignore
			this.ngModelOptions = this.ngModelCtrl.$options;

			if (this.placeholder) {
				this.$inputElement.attr('placeholder', this.placeholder);
			}

			this.debounceUpdate = this.$parse(this.ngModelOptions.getOption('debounce'))(this.$scope);

			this.ngModelCtrl.$validators.validAddress = () => this.value?.country?.length === 1;
		}
	}
}

export default PostalAddressController;
